<div *transloco="let tc; read: i18nScope + '.common'">
  <button
    mat-button
    #menuTrigger="matMenuTrigger"
    #menuTriggerButton
    (menuOpened)="menuOpened()"
    (menuClosed)="menuClosed()"
    [matMenuTriggerFor]="menu"
    [disabled]="disabled"
    class="select-button"
  >
    <div class="position-relative">
      <span [ngClass]="{ 'text-primary fw-bold': !!selectedItem }">{{ displayText }}</span>
      <span *ngIf="showClearButton" class="clear-button" (click)="clearSelection(); $event.stopPropagation()">
        <i class="fa fa-times"></i>
      </span>
    </div>
  </button>

  <mat-menu #menu="matMenu" [xPosition]="xPosition" [yPosition]="yPosition" class="filter-select-menu-container position-absolute">
    <div
      (click)="$event.stopPropagation(); searchInput.focus()"
      #menuContent
      class="menu-content"
      [ngStyle]="{ 'padding-left': menuPaddingX + 'px', 'padding-right': menuPaddingX + 'px', 'max-width': itemsWidthPx + 'px', 'min-width': itemsWidthPx + 'px' }"
    >
      <div class="input-group d-flex p-0">
        <input
          #searchInput
          mat-menu-item
          [class.mat-mdc-menu-item]="false"
          [(ngModel)]="filterText"
          (ngModelChange)="onSearchInput($event)"
          (keydown)="filterInputKeydown($event)"
          [placeholder]="placeholder || tc('controls.search')"
          class="form-control"
        />
      </div>

      <ngb-alert class="mt-2 d-flex align-items-center" type="info" *ngIf="filterText && filterText.length < minSearchLength" [dismissible]="false">
        <i class="fa fa-info-circle"></i>
        <span class="ms-2 min-length-hint">
          {{ tc('components.minSearchLength', { count: minSearchLength }) }}
        </span>
      </ngb-alert>

      <div *ngIf="(isSearching$ | async) && filterText.length >= minSearchLength" class="loading-indicator mt-2">
        <div class="loading-icon">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div class="loading-text">
          {{ tc('components.searching') }}
        </div>
      </div>

      <div *ngIf="!(isSearching$ | async) && filterText.length >= minSearchLength" class="results-section">
        <ngx-simplebar [style.max-height]="itemsMaxHeightPx + 'px'" class="mt-1">
          <ng-container *ngIf="searchResults$ | async as results">
            <div *ngIf="results.length === 0" class="no-results mt-2">
              <div class="no-results-icon">
                <i class="fa fa-search"></i>
              </div>
              <div class="no-results-text">
                {{ tc('components.noResults') }}
              </div>
            </div>
            <div *ngFor="let item of results" (click)="selectItem(item)" class="menu-item">
              <div class="menu-item-title" [innerHTML]="item.title | highlight:filterText"></div>
              <div *ngIf="showItemDescription && item.description" class="menu-item-description">{{ item.description }}</div>
            </div>
          </ng-container>
        </ngx-simplebar>
      </div>
    </div>
  </mat-menu>
</div>
